<template>
  <div
    class="w-50 absolute top-50 left-50 pa5 flex align-center justify-center"
    style="height: 95%; transform: translate(-50%, -50%); background-position: center; background-repeat: no-repeat; background-size: contain; mix-blend-mode: multiply;"
    :style="'background-image: url(' + content.src + ')'"
  >
    <MarkerHotspot
      v-for="(item, index) in markers"
      :key="index"
      :brand="brand"
      :content="item"
      :index="index"
    />
  </div>
</template>

<script>
import MarkerHotspot from '@/components/property/MarkerHotspot'

export default {
  props: {
    brand: {
      type: String,
      default: 'lh'
    },
    content: {
      type: Object,
      default: null
    },
    hotspots: {
      type: Array,
      default: null
    },
    markers: {
      type: Array,
      default: null
    }
  },
  components: {
    MarkerHotspot
  }
}
</script>
